import React, { useState } from 'react'
import {
  Button,
  DialogOverlay,
  DialogOverlayActions,
  DialogOverlayFooter,
  List,
  ListItem,
  Row,
  Skeleton,
} from '@fs/zion-ui'
import { i18n } from '@fs/zion-locale'
import ZionForm, { FormTextField, useZionForm } from '@fs/zion-form'
import { useLazyQuery } from '@apollo/client/react'
import { useQueryParams } from '@fs/zion-router'
import { MenuNewWindow, NoticeInfo } from '@fs/zion-icon'

import { getEncodedArk } from 'helpers'
import { overlayShape } from 'objectShapes'
import { volumeSetsByImageGroupNumber } from 'queries/volumeSetQueries'
import transl from './ImageGroupNumberSearchDialog.transl'

export default function ImageGroupNumberSearchDialog({ overlay }) {
  const [requestVolumeSets] = useLazyQuery(volumeSetsByImageGroupNumber)
  const { query } = useQueryParams()
  const [imageGroupNumber, setImageGroupNumber] = useState()
  const [loading, setLoading] = useState(false)
  const [parentGroups, setParentGroups] = useState()
  const methods = useZionForm({ defaultValues: { imageGroupNumber: '' } })

  function generateImageViewerUrl({ firstChildImageApid, volumeSetGroupId }) {
    const baseUrl = `${window.location.origin}/ark:/61903/${getEncodedArk({
      imageApids: [firstChildImageApid],
    })}`
    const params = new URLSearchParams({
      groupId: volumeSetGroupId,
      volumeSetSearch: query.volumeSetSearch,
      view: 'explore',
    })
    return `${baseUrl}?${params.toString()}`
  }

  function handleSubmit(values) {
    setImageGroupNumber(values.imageGroupNumber)
    setParentGroups()
    setLoading(true)

    requestVolumeSets({ variables: values })
      .then(({ data }) => {
        setLoading(false)
        setParentGroups(data.volumeSetsByImageGroupNumber)
      })
      .catch((error) => {
        console.error('error requesting volume sets', error)
        setLoading(false)
      })
  }

  return (
    <DialogOverlay {...overlay} title={transl.heading()}>
      <ZionForm methods={methods} onSubmit={handleSubmit}>
        <Row>
          <FormTextField autoComplete="off" clearable growX label={transl.label()} name="imageGroupNumber" />
          <Button alignY="nextToInput" disabled={!methods.watch('imageGroupNumber')} emphasis="high" type="submit">
            {transl.search()}
          </Button>
        </Row>
      </ZionForm>
      {loading && (
        <>
          <Skeleton.ListItem />
          <Skeleton.ListItem />
          <Skeleton.ListItem />
        </>
      )}
      {parentGroups &&
        (parentGroups.length > 0 ? (
          <>
            {transl.listHeading({ imageGroupNumber })}
            <List>
              {parentGroups.map((parentGroupObj) => (
                <ListItem
                  external
                  key={parentGroupObj.volumeSetGroupId}
                  primaryText={parentGroupObj.volumeSetGroupId}
                  endElement={<ListItem.Icon Icon={MenuNewWindow} />}
                  target="_blank"
                  to={generateImageViewerUrl(parentGroupObj)}
                />
              ))}
            </List>
          </>
        ) : (
          <Row>
            <NoticeInfo />
            {transl.noVolumeSetsFound()}
          </Row>
        ))}

      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button onClick={overlay.handleClick}>{i18n.t('common-ui:close.action')}</Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}

ImageGroupNumberSearchDialog.propTypes = {
  overlay: overlayShape.isRequired,
}
